import { ApplicationState } from "./../index";
import { BrandsEnum } from "../../enums";

const method = "POST";
const headers = { "Content-Type": "application/json" };

const Encrypt = async (state: ApplicationState): Promise<ApplicationState> => {
  if (!state.inputs.apiHost) {
    throw Error("API HOST ERROR");
  }

  const profile = state.profile;
  const inputs = state.inputs;
  const brand = inputs?.partner ?? BrandsEnum.Polestar;
  const url = `${state.inputs.apiHost}/api2/${brand}/newwebshop/Encrypt`;

  // prepare params;
  const data = {
    Phone: profile?.phone?.value ?? "",
    Email: profile?.email?.value ?? "",
  };

  const response = await fetch(`${url}`, {
    method,
    mode: "cors",
    headers,
    body: JSON.stringify(data),
  });

  const json = await response.json();

  if (response.status !== 200) {
    throw Error((json && json.Message) ?? "SERVER ERROR");
  }

  return {
    profile: {
      email: {
        secureValue: json.EncryptedEmail ?? undefined,
      },
      phone: {
        secureValue: json.EncryptedPhone ?? undefined,
      },
    },
  } as ApplicationState;
};

export default Encrypt;
